<script setup lang="ts">
import SVG from "@/stories/displays/SVG/SVG.vue";
import type { SVGName } from "@/SVGs";

interface Props {
  text?: string;
  icon?: SVGName;
  iconSize?: string;
  ariaLabel: string;
}

withDefaults(defineProps<Props>(), {
  iconSize: "1.25rem",
});

defineEmits<{
  click: [MouseEvent];
}>();
</script>

<template>
  <button
    type="button"
    :class="[
      'p-4 rounded flex gap-1 outline-2 border-none',
      'hover:outline hover:outline-2 hover:outline-neutral700',
      'focus-visible-base',
    ]"
    :ariaLabel="ariaLabel"
    @click="(event) => $emit('click', event)"
  >
    <slot>
      <SVG v-if="icon" :icon="icon" :height="iconSize" width="iconSize" />
      <span v-if="text">{{ text }}</span>
    </slot>
  </button>
</template>
